import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";

import loading from "./shared/commands/loading.reducer";
import applications from "./services/applications/reducer";
import applicationsTasks from "./services/applicationTasks/task.reducer";
import financing from "./services/financing/reducer";
import mplFinancing from "./services/financing/mpl.financing/reducer";
import payout from "./services/financing/payouts/reducer";
import invoices from "./services/invoices/reducer";
import home from "./services/home/reducer";
import uc from "./services/users/uc/reducer";
import browser from "./services/browser/reducer";
import terms from "./services/terms/reducer";
import tables from "./shared/Table/commands/table.reducer";
import organisations from "./services/users/organisations/reducer";
import depot from "./services/users/depot/reducer";
import reports from "./services/reports/reducer";
import settings from "./services/settings/reducer";
import notifications from "./shared/notifications/commands/notification.reducer";
import statistics from "./services/statistics/reducer";
import templates from "./services/templates/reducer";
import autoinvest from "./services/autoInvest/reducer";
import accountBalance from "./services/menu/dashboard/account.balance.reducer";
import marketplace from "./services/marketplace/reducer";
import timeTravel from "./reloansys.component/actions/timetravel.reducer";
import savelendMoneyReducer from "./services/savelendWithdrawals/reducer";
import borrowerOrders from "./services/borrowerOrders/reducer";

import { soldLoans } from "./services/soldLoans/reducer";
import { terminatedSaleLoans } from "./services/terminatedSaleLoans/reducer";
import { terminatedCollectionLoans } from "./services/terminatedCollectionLoans/reducer";
import referAFriend from "./services/referAFriend/reducer";
//////////////////////////////////////////////////////////////////////////////////
////// redone reducers

import accounting from "./services/accounting/reducer";
import borrowerWithdrawal from "./services/orders/userProfile/borrower.withdrawal.reducer";
import creditSettlement from "./services/creditSettlement/reducer";
import impersonate from "./services/impersonation/reducer";
import notes from "./services/notes/reducer";
import loans from "./services/loan/reducer";
import loanNotes from "./services/loan/loanNotes/reducer";
import orders from "./services/orders/reducer";
import restRepayments from "./services/loan/restRepayments/reducer";
import ssnBlock from "./services/ssnBlocking/reducer";
import transactions from "./services/transactions/reducer";
import users from "./services/users/reducer";

//import ssn from './states/users/commands/ssn.reducer';
//The profile part reducers
import userApplications from "./services/applications/user/reducer";
import userFinancings from "./services/financing/user.financing/reducer";
import userInvoices from "./services/invoices/user.invoices/reducer";
import userLoans from "./services/loan/user.reducer";
import specialAccounts from "./services/specialAccounts/reducer";
import aml from "./services/aml/reducer";
import twoStepAuthenticationReducer from "./states/2step-authentication/commands/2step.authentication.reducer";
import userCreditHistory from "./services/creditHistory/reducer";

//role and claims functionality
import claims from "./services/claims/reducer";
import system from "./services/system/reducer";
import affiliates from "./services/affiliates/reducer";

const adminAppCombine = combineReducers({
  accountBalance,
  accounting,
  affiliates,
  autoinvest,
  applications,
  applicationsTasks,
  browser,
  notes,
  borrowerOrders: borrowerOrders,
  claims,
  creditSettlement,
  depot,
  financing,
  form: formReducer,
  home,
  invoices,
  loading,
  loanNotes,
  loans,
  notifications,
  //marketplace,
  orders,
  organisations,
  payout,
  reports,
  routing: routerReducer,
  settings,
  //ssn,
  specialAccounts,
  statistics,
  tables,
  templates,
  terms,
  timeTravel,
  transactions,
  marketplace,
  mplFinancing,
  uc,
  users,
  twoStepAuthenticationReducer,
  savelendMoneyReducer,
  terminatedSaleLoans,
  terminatedCollectionLoans,
  soldLoans,
  ///////////////////
  ssnBlock,
  impersonate,
  restRepayments,
  // The profile part reducers
  userApplications: userApplications,
  userFinancings: userFinancings,
  userInvoices: userInvoices,
  userLoans: userLoans,
  userCreditHistory,
  // Aml stuff
  aml,
  borrowerWithdrawal,
  referAFriend,
  system,
});

export default adminAppCombine;
